import React from 'react'
import FormROValue from '../../../../library/form/components/FormROValue1';

const ItemQVPurchaseRow = (props) => {
    const { formObject, rowKey } = props;

    return (
        <ul className="uiDPEditLine">
            <li className="uiColumnCenter uiColumn90">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "transactionDate" }} />
            </li>
            <li className="uiColumnCenter uiColumn170">
                <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "profileName" }} />
            </li>
            <li className="uiColumnCenter uiColumn70">
                <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "quantity" }} />
            </li>
            <li className="uiColumnCenter uiColumn70">
                <FormROValue className="uiBlue" format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "unitPrice" }} />
            </li>
        </ul>
    )
}

export default ItemQVPurchaseRow
